import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-term-e",
  "use": "icon-ib-term-e-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-term-e\">\r\n    <path d=\"M480.768 139.52a48 48 0 0 1 62.464 0l336 288a48 48 0 0 1-62.464 72.96L560 280.32v567.637333a48 48 0 0 1-96 0V280.362667l-256.768 220.074666a48 48 0 0 1-62.464-72.874666l336-288z\" p-id=\"5322\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol